'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input$1 = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var useMounted = require('../../../../hooks/use-mounted.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
var input = require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
var iconButton = require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
var textfieldBody = require('../../../internal/textfield/textfield-body.js');
var textfieldHeader = require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
var textfieldInner = require('../../../internal/textfield/textfield-inner.js');
var textfieldWrapper = require('../../../internal/textfield/textfield-wrapper.js');
var baseTextfield = require('../../textfield/base-textfield/base-textfield.js');
require('../../textfield/standard-textfield/standard-textfield.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardQuantity = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { bodyProps , className , decrementButtonProps , defaultValue =0 , disabled , error , errorPosition , errorProps , headerProps , helpText , helpTextProps , id , incrementButtonProps , innerProps , labelPosition , labelProps , labels , look , max , min =0 , name , onBlur , onChange , onQuantityChange , pattern , readOnly , required , showLabel , step =1 , textfieldProps , wrapperRef , ...otherProps } = props;
    const { decrementLabel , incrementLabel , label , requiredLabel  } = labels;
    const hasError = !!error;
    const hasHelpText = !!helpText;
    const hasRequired = required && !!requiredLabel;
    const helpTextId = `${id}-help-text`;
    const inlineAlertId = `${id}-inline-alert`;
    const isMounted = useMounted.useMounted();
    const [value, setValue] = React.useState(defaultValue);
    const hasValue = value !== undefined;
    const atMax = hasValue && max === value;
    const atMin = hasValue && min === value;
    React.useEffect(()=>{
        if (isMounted && onQuantityChange) {
            onQuantityChange(value);
        }
    }, [
        value
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const onDecrement = ()=>{
        if (value !== undefined) {
            const newValue = value - step;
            if (newValue >= min) {
                setValue(newValue);
            }
        }
    };
    const onIncrement = ()=>{
        if (value !== undefined) {
            const newValue = value + step;
            if (max === undefined || max !== undefined && newValue <= max) {
                setValue(newValue);
            }
        }
    };
    return /*#__PURE__*/ React__default.default.createElement(textfieldWrapper.TextfieldWrapper, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-quantity__standard': true,
            'bf-quantity__standard--disabled': disabled,
            'bf-quantity__standard--error': hasError,
            'bf-quantity__standard--help-text': hasHelpText,
            [`bf-quantity__standard--label-${labelPosition}`]: showLabel,
            'bf-quantity__standard--label-hidden': !showLabel,
            [`bf-quantity__standard--look-${look}`]: look,
            'bf-quantity__standard--readonly': readOnly,
            'bf-quantity__standard--required': hasRequired,
            [`${className}`]: !!className
        }),
        labelPosition: labelPosition,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(textfieldHeader.TextfieldHeader, _extends({}, headerProps, {
        error: error,
        errorPosition: errorPosition,
        errorProps: errorProps,
        htmlFor: id,
        inlineAlertId: inlineAlertId,
        label: label,
        labelPosition: labelPosition,
        labelProps: labelProps,
        required: required,
        requiredLabel: requiredLabel,
        showLabel: showLabel
    })), /*#__PURE__*/ React__default.default.createElement(textfieldBody.TextfieldBody, _extends({}, bodyProps, {
        disabled: disabled,
        error: error,
        errorPosition: errorPosition,
        errorProps: errorProps,
        helpText: helpText,
        helpTextId: helpTextId,
        helpTextProps: helpTextProps,
        inlineAlertId: inlineAlertId,
        labelPosition: labelPosition,
        look: look
    }), /*#__PURE__*/ React__default.default.createElement(textfieldInner.TextfieldInner, _extends({}, innerProps), /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, _extends({}, decrementButtonProps, {
        className: classnames__default.default({
            'bf-quantity__button': true,
            'bf-quantity__decrement': true,
            [`${decrementButtonProps?.className}`]: !!decrementButtonProps?.className
        }),
        disabled: atMin || readOnly || disabled,
        icon: fontIcon.FontIcons.PriorityMedium,
        label: decrementLabel,
        look: button.ButtonLooks.Tertiary,
        onClick: ()=>{
            onDecrement();
        }
    })), /*#__PURE__*/ React__default.default.createElement(baseTextfield.BaseTextfield, _extends({}, textfieldProps, {
        "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
        "aria-disabled": disabled,
        "aria-invalid": hasError,
        className: classnames__default.default({
            'bf-quantity__textfield': true,
            'bf-quantity__textfield--xsmall': hasValue && value >= 100 && value < 999,
            'bf-quantity__textfield--small': hasValue && value >= 1000 && value <= 9999,
            'bf-quantity__textfield--medium': hasValue && value >= 10000 && value <= 99999,
            'bf-quantity__textfield--large': hasValue && value >= 100000 && value <= 999999,
            'bf-quantity__textfield--xlarge': hasValue && value >= 1000000,
            [`${textfieldProps?.className}`]: !!textfieldProps?.className
        }),
        disabled: disabled,
        id: id,
        inputMode: "numeric",
        max: max,
        min: min,
        name: name,
        onBlur: (e)=>{
            const { target  } = e;
            if (target.value === '') {
                setValue(defaultValue);
            }
            if (onBlur) {
                onBlur(e);
            }
        },
        onChange: (e)=>{
            const { target  } = e;
            if (target.value === '') {
                setValue(undefined);
            } else if (!Number.isNaN(target.value)) {
                setValue(Number(target.value));
            }
            if (onChange) {
                onChange(e);
            }
        },
        pattern: pattern,
        readOnly: readOnly,
        ref: ref,
        required: required,
        step: step,
        type: "number",
        value: value
    })), /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, _extends({}, incrementButtonProps, {
        className: classnames__default.default({
            'bf-quantity__button': true,
            'bf-quantity__increment': true,
            [`${incrementButtonProps?.className}`]: !!incrementButtonProps?.className
        }),
        disabled: atMax || readOnly || disabled,
        icon: fontIcon.FontIcons.Plus,
        label: incrementLabel,
        look: button.ButtonLooks.Tertiary,
        onClick: ()=>{
            onIncrement();
        }
    })))));
});
const Quantity = styled__default.default(BaseStandardQuantity)`
  .bf-textfield__inner {
    display: flex;
  }

  .bf-quantity__textfield {
    ${input.baseInputStyle}
    ${()=>input.getInputPadding({
        after: true,
        before: true
    })}
    ${()=>input.getInputBorderRadius({
        after: true,
        before: true
    })}
    ${({ error , look  })=>input.getInputTheme({
        after: true,
        before: true,
        error,
        look
    })}
    text-align: center;
    width: 48px;
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      appearance: none;
      margin: 0;
    }
  }

  .bf-quantity__textfield--xsmall {
    width: 57px;
  }

  .bf-quantity__textfield--small {
    width: 66px;
  }

  .bf-quantity__textfield--medium {
    width: 75px;
  }

  .bf-quantity__textfield--large {
    width: 84px;
  }

  .bf-quantity__textfield--xlarge {
    width: 92px;
  }

  .bf-quantity__button {
    width: 50px;
    ${({ disabled , error , look  })=>input.getInputAddonButtonTheme({
        disabled,
        error,
        look
    })}
  }

  .bf-quantity__decrement {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .bf-quantity__increment {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  .bf-button__font-icon {
    font-size: 11px;
  }
`;
const StandardQuantity = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { errorPosition =input$1.InputErrorPositions.Bottom , labelPosition =input$1.InputLabelPositions.Top , look =input$1.InputLooks.Default , showLabel =true , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Quantity, _extends({}, otherProps, {
        errorPosition: errorPosition,
        labelPosition: labelPosition,
        look: look,
        ref: ref,
        showLabel: showLabel
    })));
});

exports.BaseStandardQuantity = BaseStandardQuantity;
exports.StandardQuantity = StandardQuantity;
//# sourceMappingURL=standard-quantity.js.map
